<template>
  <el-dialog
    title="选择模板"
    :visible="templateUpVisi"
    :close-on-click-modal="false"
    width="50%"
    @close="closePup"
  >
    <template v-if="!isInDingTalk">
      <el-tabs v-model="activeName" @tab-click="tabClick">
        <el-tab-pane
          v-for="(user, i) of totalAccountList"
          :key="i"
          :label="user.corpName || user.name || user.username"
          :name="'user_' + i"
        >
          <p>
            提示：该方式支持多模板发起，但会清除原模板预设的签章信息，如需保留原有信息，请从<span
              style="font-weight: bold; cursor: pointer"
              @click="templateManageFn"
            >
              模板管理 </span
            >发起。
          </p>
          <div class="" v-loading="loading">
            <div class="search">
              <el-input
                placeholder="请输入模板名称"
                v-model="tplName"
                size="small"
                clearable
                style="width: 255px; margin-right: 10px"
              >
              </el-input>
              <el-button size="small" @click="searchHand">查询</el-button>
              <el-button size="small" @click="rest">重置</el-button>
            </div>
            <!-- list -->
            <div class="list-box">
              <el-card
                shadow="hover"
                v-for="temp of templateList"
                :key="temp.tplIdSec"
                class="list-card"
                :class="haveChecked(temp) ? 'tpl-active' : ''"
                @click.native="tabItemActive(temp)"
                @dblclick.native="dbActive(temp)"
              >
                <div class="tpl-box">
                  <p>
                    <template>
                      <img v-if="beWord(temp.tplName)" style="max-width: 30px; margin-right: 10px" src="/images/advancedVersion/file_1.png" alt="">
                      <img v-else style="max-width: 30px; margin-right: 10px" src="/images/advancedVersion/pdf_1.png" alt="">
                    </template>
                    <span>{{ temp.tplName.lastIndexOf(".") > -1 ? temp.tplName.substring(0,temp.tplName.lastIndexOf(".")) : temp.tplName }}</span>
                  </p>
                  <span v-show="haveChecked(temp)"
                    ><img src="/images/check.png" alt="" width="25"
                  /></span>
                  <!-- <el-button
                    v-if="!(temp.useTo && temp.useTo === 1) && !isInDingTalk"
                    type="primary"
                    plain
                    size="small"
                    @click="changeAccount(temp)"
                    >单模板发起</el-button
                  > -->
                </div>
              </el-card>
              <el-empty
                description="暂无数据"
                v-show="templateList.length === 0"
              ></el-empty>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </template>
    <template v-if="isInDingTalk">
      <p style="margin-top: 10px;">
        提示：该方式支持多模板发起，但会清除原模板预设的签章信息，如需保留原有信息，请从<span
          style="font-weight: bold; cursor: pointer"
          @click="templateManageFn"
        >
          模板管理 </span
        >发起。
      </p>
      <div class="" v-loading="loading">
        <div class="search">
          <el-input
            placeholder="请输入模板名称"
            v-model="tplName"
            size="small"
            clearable
            style="width: 255px; margin-right: 10px"
          >
          </el-input>
          <el-button size="small" @click="searchHand">查询</el-button>
          <el-button size="small" @click="rest">重置</el-button>
        </div>
        <!-- list -->
        <div class="list-box">
          <el-card
            shadow="hover"
            v-for="temp of templateList"
            :key="temp.tplIdSec"
            class="list-card"
            :class="haveChecked(temp) ? 'tpl-active' : ''"
            @click.native="tabItemActive(temp)"
            @dblclick.native="dbActive(temp)"
          >
            <div class="tpl-box">
              <p>
                <template>
                  <img v-if="beWord(temp.tplName)" style="max-width: 30px; margin-right: 10px" src="/images/advancedVersion/file_1.png" alt="">
                  <img v-else style="max-width: 30px; margin-right: 10px" src="/images/advancedVersion/pdf_1.png" alt="">
                </template>
                <span>{{ temp.tplName.lastIndexOf(".") > -1 ? temp.tplName.substring(0,temp.tplName.lastIndexOf(".")) : temp.tplName }}</span>
              </p>
              <span v-show="haveChecked(temp)"
                ><img src="/images/check.png" alt="" width="25"
              /></span>
              <!-- <el-button
                v-if="!(temp.useTo && temp.useTo === 1) && !isInDingTalk"
                type="primary"
                plain
                size="small"
                @click="changeAccount(temp)"
                >单模板发起</el-button
              > -->
            </div>
          </el-card>
          <el-empty
            description="您的企业未授权模版给您，请联系管理员处理！"
            v-show="templateList.length === 0"
          ></el-empty>
        </div>
      </div>
    </template>
    <!--分页栏-->
    <el-row
      class="pageation row"
      :style="{ marginLeft: $route.query.match == -1 ? '70px' : 0 }"
    >
      <el-col :span="24" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagenation.itemPage"
          :page-size="pagenation.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :pager-count="5"
          layout="sizes, prev, pager, next, total"
          :total="pagenation.pageTotal"
        />
        <el-go
          :page-size="pagenation.pageSize"
          :total="pagenation.pageTotal"
          @current-change="handleCurrentChange"
        ></el-go>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closePup" size="small">取 消</el-button>
      <el-button type="primary" size="small" @click="tplConfirm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import ElGo from "../../../components/go/Go.vue";
// API
import { ApiMethods } from "../../../assets/js/http-serve/http-methods";
import { setCurrentUser } from "@/assets/js/http-serve/corp/common";
// tool
import { mapGetters } from "vuex";
import { isInDingTalk } from "@/assets/js/utils/ding-env";

export default {
  components: { ElGo },
  props: { templateUpVisi: Boolean, fileList: { type: Array, default: [] } },
  data () {
    return {
      isInDingTalk,
      checkTempList: [],
      activeName: "user_0",
      pagenation: {
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0
      },
      tplName: "",
      templateList: [], // 模板列表
      templateAPI: ApiMethods.templateAPI,
      loading: true
    };
  },
  methods: {
    // 判断文件是否是doc类型
      beWord(fileName) {
        let filesuffix = "";
        if (fileName) {
          let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
          let namelength = fileName.length; //取到文件名长度
          filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
        }
        return filesuffix === "doc" || filesuffix === "docx";
      },
    templateManageFn () {
      this.$router.push({ path: "/tpl/general" });
    },
    handleClose () { },
    // 切换主体
    changeAccount (item) {
      const arr = this.activeName.split("_");
      const user = this.totalAccountList[parseInt(arr[arr.length - 1])];
      if (user.corpName && this.$store.getters.authUser.identityAuth === -1) {
        this.authDialog = true;
        return;
      }
      this.$confirm("确定要以当前企业/个人作为发起主体吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          setCurrentUser(user).finally(async () => {
            await this.$store.dispatch("setIgnoreChangePage", false);
            await this.tplItemUp(item);
          });
        })
        .catch(err => err);
    },
    // 单模板发起
    tplItemUp (item) {
      if (item.tplVersion === 2 && item.status === 1) {
        return this.$message.warning("模板未完成，请发布后使用");
      }
      const tplAPI =
        item.tplVersion === 2
          ? this.templateAPI.multiTpl2
          : this.templateAPI.templateInfo;
      const arr = this.activeName.split("_");
      const user = this.totalAccountList[parseInt(arr[arr.length - 1])];
      tplAPI({ tplIdSec: item.tplIdSec }).then(res => {
        if (!res.success) return this.$message.error(res.description);
        const { data } = res;
        switch (item.tplVersion) {
          case 1:
            this.$router.push({
              path: "/tpl/add/apply",
              query: { tplId: data.tplId, isAuth: 1, userType: user.userType }
            });
            break;
          case 2:
            this.$router.push({
              path: "/advancedVersion/writeVariables",
              query: { id: data.tplId, userType: user.userType }
            });
            break;
          default:
            this.$router.push({
              path: "/tpl/add/apply",
              query: { tplId: data.tplId, userType: user.userType }
            });
            break;
        }
      });
    },
    // 分页
    handleSizeChange (val) {
      this.pagenation.itemPage = 1;
      this.pagenation.pageSize = val;
      this.queryList();
    },
    handleCurrentChange (val) {
      this.pagenation.itemPage = val;
      this.queryList();
    },
    // 关闭弹窗
    closePup () {
      this.$emit("update:templateUpVisi", false);
    },
    // 切换tab
    tabClick (tabItem) {
      this.queryList();
    },
    // 选择tabitem
    async tabItemActive (temp) {
      if (temp.tplVersion === 2 && temp.status === 1) {
        return this.$message.warning("模板未完成，请发布后使用");
      }
      const checked = this.haveChecked(temp);
      if (checked) {
        this.checkTempList.forEach((item, i) => {
          if (item.tplIdSec === temp.tplIdSec) {
            this.checkTempList.splice(i, 1);
          }
        });
      } else {
        let newTemp = temp;
        if (temp.useTo && temp.useTo === 1) {
          // 纯文件模板查询详情
          const info = await this.getInfo(temp);
          const { files } = info.context;
          newTemp = files[0];
          if(!newTemp.sourceFile) newTemp.sourceFile={}
          newTemp.sourceFile.fileName = newTemp.fileName;
          newTemp.tplIdSec = temp.tplIdSec;
          newTemp.useTo = temp.useTo;
        }
        this.checkTempList.push(newTemp);
      }
    },
    // 快速选择
    async dbActive (temp) {
      await this.tabItemActive(temp);
      await this.tplConfirm();
    },
    // 重置
    rest () {
      this.tplName = "";
      this.pagenation.itemPage = 1;
      this.queryList();
    },
    // 搜索
    searchHand () {
      this.pagenation.itemPage = 1;
      this.queryList();
    },
    // 查询模板列表
    queryList () {
      this.loading = true;
      const arr = this.activeName.split("_");
      const currtent = this.totalAccountList[parseInt(arr[arr.length - 1])];
      const { itemPage, pageSize } = this.pagenation,
        { tplName } = this;
      const param = {
        corpUserId: currtent.hasOwnProperty("corpUserId")
          ? currtent.corpUserId
          : "",
        itemPage,
        pageSize,
        tplName
      };
      this.templateAPI
        .templateList(param)
        .then(res => {
          if (!res.success) return this.$message.error(res.description);
          this.templateList = res.data;
          this.pagenation.pageTotal = res.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 查询详情
    getInfo (item) {
      return new Promise((reslove, reject) => {
        try {
          this.templateAPI.multiTpl2({ tplIdSec: item.tplIdSec }).then(res => {
            if (!res.success) {
              this.$message.error(res.description);
              reslove({ success: res.success });
            }
            reslove(res.data);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    // confirm
    async tplConfirm () {
      if(parseInt(this.checkTempList.length + this.fileList.length) === 30) this.$message.warning('最多只能上传30个文件')
      this.checkTempList.forEach(async (elem, i) => {
        if (!elem.useTo) {
          elem.isTpl = true;
        }
      });
      this.$emit("activeTplItem", this.checkTempList);
      this.closePup();
    },
    haveChecked (temp) {
      return this.checkTempList.some(item => temp.tplIdSec === item.tplIdSec);
    }
  },
  computed: {
    ...mapGetters(["currentAuthUser"]),
    totalAccountList () {
      let arr = [this.$store.getters.allAuthUser.accountInfoVO],
        binds = this.$store.getters.allAuthUser.bindCorpUsers;
      let arr2 = binds.filter(item => {
        if (isInDingTalk) {
          // 钉钉环境
          const info = JSON.parse(sessionStorage.getItem("dingloginInfo"));
          if (isInDingTalk) {
            return info.jzqCorpId === item.corpId;
          }
        } else {
          return item.userStemFrom !== -16;
        }
      });
      let newArr = arr.concat(arr2);
      return newArr;
    }
  },
  watch: {
    templateUpVisi (newVal) {
      if (newVal) {
        this.totalAccountList.forEach((item, i) => {
          if (this.currentAuthUser.corpUserId === item.corpUserId) {
            this.activeName = `user_${i}`;
          }
        });
        this.checkTempList = this.fileList.filter(item => item.isTpl);
        this.queryList();
      }
    }
  }
};
</script>

<style scoped lang="less">
.search {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  justify-items: center;
}
.list-box {
  height: 50vh;
  margin: 10px 0;
  overflow-y: auto;
  .list-card {
    margin-bottom: 4px;
    cursor: pointer;
    &:hover {
      background-color: #ebeef5;
    }
    .tpl-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
.tpl-active {
  background-color: #ebeef5;
  border: 1px solid #ec1c1c;
}
</style>
<style lang="less">
.el-tabs__nav-scroll {
  /*padding-left: 25px;*/
}
.el-tabs--bottom .el-tabs__header.is-bottom {
  margin-top: 0;
}
.el-tabs__item {
  font-weight: bold;
  font-size: 15px;
  padding: 0 12px !important;
}
.el-tabs__active-bar {
  color: #ec1c1c;
  background-color: #ec1c1c;
}
.el-tabs__item.is-active {
  color: #ec1c1c;
}
.el-tabs__item:hover {
  color: #ec1c1c;
}
.el-tabs__nav-wrap::after {
  height: 1px;
}
</style>



// WEBPACK FOOTER //
// pages/initiation/components/dialogPup.vue